import { Tab, Tabs, Box } from '@mui/material';
import { BarChart as BarChartIcon, Timeline as TimelineIcon } from '@mui/icons-material';
import { Link, useLocation, useParams, useNavigate, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ChartReview from './ChartReview';
import Trends from './Trends';
import { useEffect } from 'react';

function ProductOrganizationQuantitative() {
  const { opk } = useParams();
  const { ean } = useParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === `/profile/organizations/${opk}/products/${ean}/charts/quantitative` || pathname === `/profile/organizations/${opk}/products/${ean}/charts/quantitative/`) {
      navigate(`/profile/organizations/${opk}/products/${ean}/charts/quantitative/histogram`);
    }
  }, [pathname, opk, ean]);

  return (
    <Box>
      <Tabs value={pathname} indicatorColor="primary" textColor="primary" centered scrollButtons={false} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tab
          label={t('organizations.product.charts.reviews')}
          icon={<BarChartIcon />}
          component={Link}
          to="histogram"
          value={pathname.startsWith(`/profile/organizations/${opk}/products/${ean}/charts/quantitative/histogram`) ? pathname : `/profile/organizations/${opk}/products/${ean}/charts/quantitative`}
        />
        <Tab label={t('organizations.product.charts.searchTerms')} icon={<TimelineIcon />} component={Link} to="trends" value={`/profile/organizations/${opk}/products/${ean}/charts/quantitative/trends`} />
      </Tabs>
      <Routes>
        <Route path="histogram" element={<ChartReview />} />
        <Route path="trends" element={<Trends />} />
      </Routes>
    </Box>
  );
}

export default ProductOrganizationQuantitative;
